import { createStore } from "vuex";

const store = createStore({
  state: {
    user: JSON.parse(localStorage.getItem("user")) || null, // Initialize from storage
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("userToken", user.token);
    },
    LOGOUT(state) {
      state.user = null;
      localStorage.removeItem("user");
      localStorage.removeItem("userToken");
    },
  },
  actions: {
    login({ commit }, user) {
      commit("SET_USER", user);
    },
    logout({ commit }) {
      commit("LOGOUT");
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.user,
  },
});

export default store;
